export const DEFAULT_SORT_ATTRIBUTE = "Relevance"

export const SortOrderEnum = {
  Desc: "DESC",
  Asc: "ASC",
}

export const i18n = {
  sort: "Sort:",
}



// WEBPACK FOOTER //
// ./src/containers/Kendra/sorting/constants.js